import React from "react";
import ResourcePage from "../components/ResourcePage";
import OrdersCompare from "../components/orders/OrdersCompare";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function Orders() {
  return (
    <div className="space-y-4" data-testid="page-orders">
      <Tabs defaultValue="confronto">
        <TabsList><TabsTrigger value="confronto" data-testid="otab-confronto">Confronto ordini · SAL · fatture</TabsTrigger><TabsTrigger value="elenco" data-testid="otab-elenco">Contratti e ordini</TabsTrigger></TabsList>
        <TabsContent value="confronto"><div className="mb-3"><h1 className="text-3xl font-display font-bold text-primary">Ordini e appalti</h1><p className="text-sm text-muted-foreground">Per ogni contratto: importo ordinato (+ varianti) vs SAL emessi vs fatture ricevute vs pagato, con alert sugli sforamenti</p></div><OrdersCompare /></TabsContent>
        <TabsContent value="elenco"><ResourcePage resource="orders" /></TabsContent>
      </Tabs>
    </div>
  );
}
